import { Pipe, PipeTransform } from '@angular/core';
import { RankingDto } from '@aoe/client';
import * as _ from 'lodash-es';

@Pipe({
  name: 'filterRank',
  standalone: false
})
export class FilterRankPipe implements PipeTransform {

  transform(values: RankingDto[] | null, ...args: string[]): RankingDto[] {
    if (_.isEmpty(args[0]) || _.isNull(args[0]))
      return values ?? [];

    return values?.filter(r => {
      const stringToSearch = `${r.runner?.bib} ${_.toLower(r.runner?.firstName)} ${_.toLower(r.runner?.lastName)} ${_.toLower(r.runner?.club ?? '')} ${_.toLower(r.runner?.category.event)}`;
      return !_.isNull(stringToSearch.match(new RegExp(args[0], 'gi')));
    }) ?? []
  }

}
